// src/plugins/fullstory.js
import * as FullStory from '@fullstory/browser'
import deleteCookiesByOTCategory from '@/helpers/useCookiesDelete'

const FS_CATEGORY_ID = 'C0005'
const ORG_ID = 'o-232MX4-na1'

let isInitialized = false

function initFullStory() {
  if (isInitialized) return
  FullStory.init({ orgId: ORG_ID })
  isInitialized = true
  // eslint-disable-next-line no-console
  console.log('[FS] Initialized')
}

function shutdownFullStory() {
  if (window.FS) {
    window.FS.shutdown?.()
    isInitialized = false
    // eslint-disable-next-line no-console
    console.log('[FS] Shut down')

    deleteCookiesByOTCategory()
  }
}

function checkConsent() {
  const groups = window.OnetrustActiveGroups
  if (groups?.includes(FS_CATEGORY_ID)) {
    initFullStory()
  } else {
    shutdownFullStory()
  }
}

export function setupFullStoryConsentWatcher() {
  // OneTrust will call this automatically
  window.OptanonWrapper = function () {
    // eslint-disable-next-line no-console
    console.log('[OT] OptanonWrapper called')
    checkConsent()
  }

  // Also check on page load if consent already given
  if (window.OnetrustActiveGroups) {
    checkConsent()
  }
}

export function fsTrackEvent(event: string, params: Object) {
  if (window.FS) {
    window.FS.event(event, params || {})
  }
}
